import _asyncToGenerator from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/ecomm-marketplace/node_modules/@babel/runtime/regenerator/index.js";
import _ from 'lodash';
import moment from 'moment';
import { getEnabledV2OrderTypes } from 'shared/core/helpers/dispensaries';
import { defaultDurationEstimates, defaultActionEstimates } from 'shared/constants';
var getDeliveryEstimate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, skipMatrixCheck) {
    var actionEstimates, deliveryActionEstimateOrDefault, baseTimeToPrepareOrder, defaultDeliveryBuffer, rangeInMinutes, roundTo, rounded, defaultDeliveryEstimate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          actionEstimates = _ref.actionEstimates;
          deliveryActionEstimateOrDefault = _.get(actionEstimates, "delivery", defaultActionEstimates.delivery);
          baseTimeToPrepareOrder = _.get(deliveryActionEstimateOrDefault, "readyInMinutes", 25); // eslint-disable-next-line max-len
          defaultDeliveryBuffer = Math.ceil(_.get(deliveryActionEstimateOrDefault, "deliveryTimeInMinutes", 20) / 5) * 5; // round to nearest 5
          rangeInMinutes = _.get(deliveryActionEstimateOrDefault, "rangeInMinutes", 10);
          roundTo = baseTimeToPrepareOrder > 60 ? 10 : 5;
          rounded = Math.ceil(baseTimeToPrepareOrder / roundTo) * roundTo; // round to nearest 5 | 10 depending on size
          if (rounded === 0) {
            rounded = 25;
          }
          defaultDeliveryEstimate = {
            lowInMinutes: rounded + defaultDeliveryBuffer,
            highInMinutes: rounded + defaultDeliveryBuffer + rangeInMinutes
          };
          if (!skipMatrixCheck) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", {
            lowInMinutes: rounded,
            highInMinutes: rounded + rangeInMinutes
          });
        case 11:
          return _context.abrupt("return", defaultDeliveryEstimate);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getDeliveryEstimate(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getPickupEstimate = function getPickupEstimate(_ref3) {
  var actionEstimates = _ref3.actionEstimates;
  var pickupActionEstimateOrDefault = _.get(actionEstimates, "pickup", defaultActionEstimates.pickup);
  var baseTimeToPrepareOrder = _.get(pickupActionEstimateOrDefault, "readyInMinutes", 20);
  var roundTo = baseTimeToPrepareOrder > 60 ? 10 : 5;
  var rounded = Math.ceil(baseTimeToPrepareOrder / roundTo) * roundTo;
  if (rounded === 0) {
    rounded = 20;
  }
  return {
    lowInMinutes: Math.max(rounded - 5, 5),
    highInMinutes: rounded + _.get(pickupActionEstimateOrDefault, "rangeInMinutes", 5)
  };
};
export var durationEstimatesForOrder = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispensary) {
    var _ref5,
      skipMatrixCheck,
      deliveryOverride,
      pickupOverride,
      delivery,
      pickup,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref5 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, skipMatrixCheck = _ref5.skipMatrixCheck;
          deliveryOverride = _.get(dispensary, "durationEstimateOverrides.delivery", false);
          pickupOverride = _.get(dispensary, "durationEstimateOverrides.pickup", false);
          if (!(deliveryOverride !== null && deliveryOverride !== void 0 && deliveryOverride.enabled)) {
            _context2.next = 7;
            break;
          }
          _context2.t0 = deliveryOverride;
          _context2.next = 10;
          break;
        case 7:
          _context2.next = 9;
          return getDeliveryEstimate(dispensary, skipMatrixCheck);
        case 9:
          _context2.t0 = _context2.sent;
        case 10:
          delivery = _context2.t0;
          pickup = pickupOverride !== null && pickupOverride !== void 0 && pickupOverride.enabled ? pickupOverride : getPickupEstimate(dispensary);
          return _context2.abrupt("return", {
            pickup: pickup,
            delivery: delivery
          });
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function durationEstimatesForOrder(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
export var formatEstimate = function formatEstimate(actionEstimate) {
  var serviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pickup";
  var estimate = actionEstimate || defaultDurationEstimates[serviceType] || defaultDurationEstimates.pickup;
  var times = [estimate.lowInMinutes, estimate.highInMinutes].filter(function (val) {
    return val;
  }).join(' - ');
  return times ? "".concat(times, " min") : null;
};
export var getAfterHoursWindow = function getAfterHoursWindow(openInfo) {
  var _openInfo$serviceType;
  var serviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pickup";
  if (serviceType !== 'delivery' && serviceType !== 'inStorePickup' && serviceType !== 'curbsidePickup' && serviceType !== 'driveThruPickup') {
    serviceType = "pickup";
  }
  var _ref6 = (openInfo === null || openInfo === void 0 || (_openInfo$serviceType = openInfo[serviceType]) === null || _openInfo$serviceType === void 0 ? void 0 : _openInfo$serviceType.nextService) || {},
    openMoment = _ref6.openMoment,
    closeMoment = _ref6.closeMoment;
  if (!openMoment || !closeMoment) {
    return {};
  }
  var now = moment();
  var tomorrow = now.clone().add(1, "day");
  var openDayDisplay;
  if (openMoment.isSame(now, "day")) {
    openDayDisplay = "today";
  } else if (openMoment.isSame(tomorrow, "day")) {
    openDayDisplay = "tomorrow";
  } else {
    openDayDisplay = openMoment.format("M/D");
  }
  var open = openMoment.format("h:mm a");
  var close = closeMoment.format("h:mm a");
  return {
    day: openDayDisplay,
    open: open,
    close: close
  };
};
export var getCombinedV2PickupHoursWindow = function getCombinedV2PickupHoursWindow(openInfo,
// use return object from openInfoForDispensary() in helpers/dispensaries.js
dispensary) {
  var enabledV2OrderTypes = getEnabledV2OrderTypes(dispensary);
  var enabledPickupOrderTypes = _.filter(enabledV2OrderTypes, function (orderType) {
    return orderType !== "delivery";
  });

  // Get the next available opening time for the enabled pickup service types
  var availablePickupOpenTimes = _.compact(_.map(enabledPickupOrderTypes, function (orderType) {
    var _openInfo$orderType;
    return (_openInfo$orderType = openInfo[orderType]) === null || _openInfo$orderType === void 0 ? void 0 : _openInfo$orderType.nextService.openMoment;
  }));
  if (!availablePickupOpenTimes.length > 0) {
    return {};
  }
  var earliestAvailablePickupTime = moment.min(availablePickupOpenTimes);

  // Get the next latest closing time for the enabled pickup service types
  // that falls on the same day as the earliest available pickup time
  var availablePickupCloseTimes = _.filter(_.compact(_.map(enabledPickupOrderTypes, function (orderType) {
    var _openInfo$orderType2;
    var closeMoment = (_openInfo$orderType2 = openInfo[orderType]) === null || _openInfo$orderType2 === void 0 ? void 0 : _openInfo$orderType2.nextService.closeMoment;
    if (!closeMoment) {
      return null;
    }
    if (closeMoment.format("h:mm a") === '12:00 am') {
      // Since midnight closing times are stored as 12:00 am,
      // we need to subtract 1 minute for the correct closing time string.
      return closeMoment.clone().subtract(1, "m");
    }
    return closeMoment;
  })), function (closeMoment) {
    return closeMoment.isSame(earliestAvailablePickupTime, "day");
  });
  var latestAvailablePickupTime = moment.max(availablePickupCloseTimes);
  if (!earliestAvailablePickupTime || !latestAvailablePickupTime) {
    return {};
  }
  var now = moment();
  var tomorrow = now.clone().add(1, "day");
  var openDayDisplay;
  if (earliestAvailablePickupTime.isSame(now, "day")) {
    openDayDisplay = "today";
  } else if (earliestAvailablePickupTime.isSame(tomorrow, "day")) {
    openDayDisplay = "tomorrow";
  } else {
    openDayDisplay = earliestAvailablePickupTime.format("M/D");
  }
  var open = earliestAvailablePickupTime.format("h:mm a");
  var close = latestAvailablePickupTime.format("h:mm a");
  return {
    day: openDayDisplay,
    open: open,
    close: close
  };
};
export var formatAfterHoursEstimate = function formatAfterHoursEstimate(_ref7) {
  var day = _ref7.day,
    open = _ref7.open,
    close = _ref7.close;
  if (!day || !open || !close) {
    return "next service opportunity unknown";
  }
  return "".concat(day, ", ").concat(open, " - ").concat(close === "12:00 am" ? "11:59 pm" : close);
};
export var getServiceEstimateForCart = function getServiceEstimateForCart(Cart) {
  var _Cart$order, _Cart$order2, _Cart$order3, _Cart$openInfoForDisp;
  var serviceType = ((_Cart$order = Cart.order) === null || _Cart$order === void 0 ? void 0 : _Cart$order.deliveryOption) === 'delivery' ? 'delivery' : 'pickup';
  var afterHoursServiceType = ((_Cart$order2 = Cart.order) === null || _Cart$order2 === void 0 ? void 0 : _Cart$order2.deliveryOption) === 'pickup' ? 'inStorePickup' : (_Cart$order3 = Cart.order) === null || _Cart$order3 === void 0 ? void 0 : _Cart$order3.deliveryOption;
  var estimate = Cart.isAfterHoursOrder || !((_Cart$openInfoForDisp = Cart.openInfoForDispensary) !== null && _Cart$openInfoForDisp !== void 0 && (_Cart$openInfoForDisp = _Cart$openInfoForDisp[afterHoursServiceType]) !== null && _Cart$openInfoForDisp !== void 0 && (_Cart$openInfoForDisp = _Cart$openInfoForDisp.nextService) !== null && _Cart$openInfoForDisp !== void 0 && _Cart$openInfoForDisp.openMoment) ? _.upperFirst(formatAfterHoursEstimate(getAfterHoursWindow(Cart.openInfoForDispensary, afterHoursServiceType))) : formatEstimate(Cart.durationEstimates[serviceType], serviceType);
  return estimate;
};